import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import HeroBanner from "./HeroBanner";
import VechainEnergy from "./VechainEnergy";
import TabSection from "./TabSection";
import TrustedBy from "./TrustedBy";
import FormSection from "./FormSection";
import BlockChainApitab from "./BlockChainApitab";
import PerformanceTab from "./PerformanceTab";
import Features from "./Features";


const Home = ()=>{
    return (
        <div>
        <Header/>
        <HeroBanner/>
        <VechainEnergy/>
        <TabSection/>
        <Features/>
        <BlockChainApitab/>
        <PerformanceTab/>
        <TrustedBy/>
        <FormSection/>
        <Footer/>
        </div>
        );

}
export default Home;